export default {
  animal: 'Zviera | Zvieratá',
  client: 'Klient | Klienti',
  company: 'Spoločnosť',
  companyName: 'Meno spoločnosti',
  description: 'Popis',
  email: 'Email',
  firstName: 'Meno',
  fullName: 'Meno a Priezvisko',
  lastName: 'Priezvisko',
  name: 'Meno',
  degree: 'Titul',
  gender: 'Pohlavie',
  male: 'Mužské',
  female: 'Ženské',
  nofilled: 'Nezadané',
  notification: 'Upozornenie | Upozornenia',
  orgId: 'IČO',
  password: 'Heslo',
  passwordConfirm: 'Potvrdenie hesla',
  phone: 'Telefón',
  searchPlaceholder: 'Vyhľadávanie...',
  service: 'Služba | Služby',
  settings: 'Nastavenia',
  time: 'Čas',
  user: 'Používateľ',
  vatId: 'DIČ / IČ DPH',
  vatPayer: 'Platca DPH',
  image: 'Obrázok | Obrázky',
  businessHours: 'Otváracie hodiny'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/globals.js